(function () {
'use strict';
if (window.__blackMinuteInit) return;
window.__blackMinuteInit = true;
var cfg = readJSON('[data-black-minute-config]');
var pool = readJSON('[data-black-minute-pool]') || [];
if (!cfg || !cfg.enabled) return;
function readJSON(sel) {
var el = document.querySelector(sel);
if (!el) return null;
try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
}
var COPY = cfg.copy || {};
var DURATION = Math.max(5, parseInt(cfg.durationSeconds, 10) || 60);
var SALT = cfg.rotationSalt || 'marche-noir';
var LS_KEY = 'WdXWbC5iYskvttCH6Ovd6';
var LS_UNLOCK = '/collections/black-minute?ls=' + LS_KEY;
var clockSkewMs = 0;
function now() { return Date.now() + clockSkewMs; }
function syncServerClock() {
return new Promise(function (resolve) {
var done = false;
var finish = function (ms) { if (done) return; done = true; clockSkewMs = ms - Date.now(); resolve(); };
try {
fetch(window.location.pathname + '?_bm=' + Date.now(), { method: 'HEAD', cache: 'no-store' })
.then(function (res) {
var d = res.headers.get('date');
var t = d ? Date.parse(d) : NaN;
if (!isNaN(t)) return finish(t);
finish(cfg.shop && cfg.shop.nowEpochMs ? cfg.shop.nowEpochMs : Date.now());
})
.catch(function () { finish(cfg.shop && cfg.shop.nowEpochMs ? cfg.shop.nowEpochMs : Date.now()); });
} catch (e) { finish(cfg.shop && cfg.shop.nowEpochMs ? cfg.shop.nowEpochMs : Date.now()); }
setTimeout(function () { finish(cfg.shop && cfg.shop.nowEpochMs ? cfg.shop.nowEpochMs : Date.now()); }, 2500);
});
}
function offsetParts() {
var z = (cfg.shop && cfg.shop.tzOffset) || '+0000';
var m = /^([+-])(\d{2})(\d{2})$/.exec(z.trim());
return m ? { sign: m[1] === '-' ? -1 : 1, h: m[2], mm: m[3] } : { sign: 1, h: '00', mm: '00' };
}
function shopOffsetMinutes() { var o = offsetParts(); return o.sign * (parseInt(o.h, 10) * 60 + parseInt(o.mm, 10)); }
function offsetColon() { var o = offsetParts(); return (o.sign < 0 ? '-' : '+') + o.h + ':' + o.mm; }
function shopDateString() {
var s = new Date(now() + shopOffsetMinutes() * 60000);
return s.getUTCFullYear() + '-' + pad(s.getUTCMonth() + 1) + '-' + pad(s.getUTCDate());
}
function epochForShopTime(dateStr, hhmm) {
var t = /^(\d{1,2}):(\d{2})$/.exec((hhmm || '').trim());
var hh = t ? pad(t[1]) : '00', mm = t ? t[2] : '00';
return Date.parse(dateStr + 'T' + hh + ':' + mm + ':00' + offsetColon());
}
function dayIndex(dateStr) { return Math.floor(Date.parse(dateStr + 'T00:00:00Z') / 86400000); }
function hashStr(str) {
var h = 2166136261 >>> 0;
for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
return h >>> 0;
}
function mulberry32(seed) {
var a = seed >>> 0;
return function () {
a |= 0; a = (a + 0x6D2B79F5) | 0;
var t = Math.imul(a ^ (a >>> 15), 1 | a);
t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};
}
function seededFloat(key) { return mulberry32(hashStr(key))(); }
function shuffle(arr, seed) {
var r = mulberry32(seed), a = arr.slice();
for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(r() * (i + 1)); var tmp = a[i]; a[i] = a[j]; a[j] = tmp; }
return a;
}
function parseSchedule(text) {
var map = {};
if (!text) return map;
text.split(/\r?\n/).forEach(function (line) {
line = line.trim(); if (!line) return;
var parts = line.split('='), date = (parts[0] || '').trim();
var handle = parts.length > 1 ? parts[1].trim() : null;
if (/^\d{4}-\d{2}-\d{2}$/.test(date)) map[date] = handle || null;
});
return map;
}
function decideDay(dateStr) {
var result = { live: false, pinnedHandle: null };
var rule = cfg.liveDecision || 'every_day';
if (rule === 'every_day') { result.live = true; }
else if (rule === 'odds') {
var chance = Math.max(0, Math.min(100, parseFloat(cfg.liveChance)));
result.live = seededFloat(SALT + '|live|' + dateStr) * 100 < chance;
} else if (rule === 'manual_dates') {
var sched = parseSchedule(cfg.manualSchedule);
if (Object.prototype.hasOwnProperty.call(sched, dateStr)) { result.live = true; result.pinnedHandle = sched[dateStr]; }
}
return result;
}
function pickHandle(dateStr, manualPin) {
if (manualPin) return manualPin;
if (cfg.productSource === 'pinned') return cfg.pinnedHandle || null;
var clean = (pool || []).filter(Boolean);
if (!clean.length) return null;
var n = clean.length, di = dayIndex(dateStr);
var order = shuffle(clean, hashStr(SALT + '|order'));
return order[(((di % n) + n) % n)];
}
function fireStartEpoch(dateStr) {
if (cfg.timingMode === 'random') {
var s = toMinutes(cfg.randomStart || '10:00'), e = toMinutes(cfg.randomEnd || '18:00');
if (e < s) { var t = s; s = e; e = t; }
var pick = s + Math.floor(seededFloat(SALT + '|time|' + dateStr) * (e - s + 1));
return epochForShopTime(dateStr, minutesToHHMM(pick));
}
return epochForShopTime(dateStr, cfg.fixedTime || '13:00');
}
var activeDate, startEpoch = 0, endEpoch = 0, todayHandle = null, liveToday = false, isPreview = false;
function detectPreview() {
if (!cfg.allowPreview) return false;
var p = (cfg.previewParam || 'blackminute-preview').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
return new RegExp('[?&]' + p + '=1\\b').test(window.location.search);
}
function resolve() {
activeDate = shopDateString();
isPreview = detectPreview();
var handle = pickHandle(activeDate, null);
liveToday = !!handle;
if (!liveToday) return;
startEpoch = now();
endEpoch = startEpoch + DURATION * 1000;
todayHandle = handle;
}
function windowState() {
var t = now();
if (t < startEpoch) return 'before';
if (t < endEpoch) return 'live';
return 'after';
}
function productUrl(handle) {
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
if (root.charAt(root.length - 1) !== '/') root += '/';
return root + 'products/' + handle + '?' + (cfg.previewParam || 'blackminute-preview') + '=1&ls=' + LS_KEY;
}
function setupTeaser() {
var root = document.getElementById('black-minute-root');
if (!root) return;
var els = {
root: root,
overlay: root.querySelector('[data-bm-overlay]'),
close: root.querySelector('[data-bm-close]'),
title: root.querySelector('[data-bm-title]'),
subtitle: root.querySelector('[data-bm-subtitle]'),
time: root.querySelector('[data-bm-time]'),
progress: root.querySelector('[data-bm-progress]'),
product: root.querySelector('[data-bm-product]'),
img: root.querySelector('[data-bm-img]'),
name: root.querySelector('[data-bm-name]'),
price: root.querySelector('[data-bm-price]'),
cta: root.querySelector('[data-bm-cta]'),
ctaLabel: root.querySelector('[data-bm-cta-label]'),
ended: root.querySelector('[data-bm-ended]'),
endedText: root.querySelector('[data-bm-ended-text]'),
pill: document.querySelector('[data-bm-pill]'),
pillTime: document.querySelector('[data-bm-pill-time]')
};
var dismissKey = 'bm:dismiss:' + activeDate;
var timer = null;
function setText(el, s) { if (el) el.textContent = s == null ? '' : String(s); }
function open() {
root.hidden = false;
void root.offsetWidth;
root.classList.add('is-open');
try { localStorage.setItem('bm:seen', String(now())); } catch (e) {}
if (els.pill) { els.pill.hidden = true; els.pill.classList.remove('is-visible'); }
document.addEventListener('keydown', onEsc);
}
function close() {
root.classList.remove('is-open');
document.removeEventListener('keydown', onEsc);
setTimeout(function () { root.hidden = true; }, 500);
try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
if (windowState() === 'live' && els.pill) { els.pill.hidden = false; void els.pill.offsetWidth; els.pill.classList.add('is-visible'); }
}
function onEsc(e) { if (e.key === 'Escape') close(); }
function tick() {
var remaining = Math.max(0, endEpoch - now());
var secs = Math.max(0, Math.ceil(remaining / 1000) - 1);
var label = clockLabel(secs);
setText(els.time, label);
if (els.pillTime) setText(els.pillTime, label);
if (els.progress) els.progress.style.transform = 'scaleX(' + Math.max(0, Math.min(1, remaining / (DURATION * 1000))) + ')';
root.classList.toggle('is-urgent', secs <= 10);
if (remaining <= 0) end();
}
function start() { tick(); timer = setInterval(tick, 250); }
function end() {
if (timer) { clearInterval(timer); timer = null; }
setText(els.time, '00:00');
if (els.progress) els.progress.style.transform = 'scaleX(0)';
root.classList.add('is-ended');
setText(els.endedText, COPY.ended || 'Black Minute ended');
if (els.ended) els.ended.hidden = false;
if (els.cta) els.cta.setAttribute('disabled', 'disabled');
if (els.pill) { els.pill.hidden = true; }
}
function paint() {
setText(els.title, COPY.title || 'BLACK MINUTE');
setText(els.subtitle, COPY.subtitle || 'Available for 60 seconds');
setText(els.ctaLabel, COPY.unlock || 'Unlock the offer');
if (els.cta) {
els.cta.removeAttribute('disabled');
els.cta.onclick = function () { window.location.href = productUrl(todayHandle); };
}
if (todayHandle) {
fetch(LS_UNLOCK, { credentials: 'same-origin' })
.catch(function () {})
.then(function () { return fetch('/products/' + todayHandle + '.js', { credentials: 'same-origin' }); })
.then(function (r) { return r && r.ok ? r.json() : null; })
.then(function (p) {
if (!p || !els.product) return;
els.product.hidden = false;
setText(els.name, p.title);
var avail = (p.variants || []).filter(function (v) { return v.available; });
var sizeLabel = '';
if (avail.length === 1) sizeLabel = ' — Size ' + avail[0].title;
else if (avail.length > 1) sizeLabel = ' — Sizes ' + avail.map(function (v) { return v.title; }).join(' / ');
setText(els.price, money(p.price) + sizeLabel);
if (avail.length === 1 && els.subtitle) {
setText(els.subtitle, 'Size ' + avail[0].title + ' · 60 seconds');
}
if (avail.length && els.cta) {
els.cta.onclick = function () { window.location.href = productUrl(todayHandle) + '&variant=' + avail[0].id; };
}
var src = imageUrl(p.featured_image || (p.images && p.images[0]) || '');
if (src && els.img) { els.img.src = src; els.img.alt = p.title || ''; }
})
.catch(function () {});
}
}
function launch() {
if (!todayHandle) return;
if (!isPreview) { try { var bmSeen = parseInt(localStorage.getItem('bm:seen'), 10); if (bmSeen && (now() - bmSeen) < 86400000) return; } catch (e) {} }
paint();
var dismissed = false;
if (!isPreview) { try { dismissed = !!localStorage.getItem(dismissKey); } catch (e) {} }
if (dismissed) {
start();
if (els.pill) { els.pill.hidden = false; void els.pill.offsetWidth; els.pill.classList.add('is-visible'); }
} else {
setTimeout(function () { if (windowState() === 'live') { open(); start(); } }, isPreview ? 0 : 18000);
}
}
if (els.close) els.close.addEventListener('click', close);
if (els.overlay) els.overlay.addEventListener('click', close);
if (els.pill) els.pill.addEventListener('click', function () { if (windowState() === 'live') open(); });
var st = windowState();
if (st === 'after') return;
if (st === 'before') {
var delay = startEpoch - now();
if (delay <= 6 * 60 * 60 * 1000) setTimeout(launch, delay);
return;
}
launch();
}
function setupPDP() {
var isTodaysDrop = todayHandle && cfg.pageProductHandle === todayHandle && liveToday;
var form = document.querySelector('form[action*="/cart/add"]');
var atc = form ? (form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]')) : (document.querySelector('button[name="add"]'));
if (!form && !atc) return;
var allowed = function () { return true; };
if (form) {
form.addEventListener('submit', function (e) {
if (!allowed()) { e.preventDefault(); e.stopImmediatePropagation(); flash(); }
}, true);
}
if (atc) {
atc.addEventListener('click', function (e) {
if (!allowed()) { e.preventDefault(); e.stopImmediatePropagation(); flash(); }
}, true);
}
var chip = document.createElement('div');
chip.className = 'bm-pdp';
chip.innerHTML =
'<div class="bm-pdp__row">' +
'<span class="bm-pdp__label">' + escapeHtml(COPY.title || 'BLACK MINUTE') + '</span>' +
'<span class="bm-pdp__time" data-bm-pdp-time>00:00</span>' +
'</div>' +
'<div class="bm-pdp__bar"><span class="bm-pdp__bar-fill" data-bm-pdp-bar></span></div>' +
'<p class="bm-pdp__msg" data-bm-pdp-msg></p>';
var anchor = atc ? (atc.closest('.product-form__buttons') || atc.closest('product-form') || atc.parentNode) : form;
if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(chip, anchor);
else if (form) form.insertBefore(chip, form.firstChild);
var timeEl = chip.querySelector('[data-bm-pdp-time]');
var barEl = chip.querySelector('[data-bm-pdp-bar]');
var msgEl = chip.querySelector('[data-bm-pdp-msg]');
var timer = null;
function flash() {
chip.classList.remove('bm-pdp--flash');
void chip.offsetWidth;
chip.classList.add('bm-pdp--flash');
}
function lockVisual(on) { return; }
function renderLive() {
chip.classList.add('is-live'); chip.classList.remove('is-locked', 'is-ended');
msgEl.textContent = '';
lockVisual(false);
tick();
timer = setInterval(tick, 250);
}
function tick() {
var remaining = Math.max(0, endEpoch - now());
var secs = Math.max(0, Math.ceil(remaining / 1000) - 1);
timeEl.textContent = clockLabel(secs);
if (barEl) barEl.style.transform = 'scaleX(' + Math.max(0, Math.min(1, remaining / (DURATION * 1000))) + ')';
chip.classList.toggle('is-urgent', secs <= 10);
if (remaining <= 0) endLive();
}
function endLive() {
if (timer) { clearInterval(timer); timer = null; }
timeEl.textContent = '00:00';
if (barEl) barEl.style.transform = 'scaleX(0)';
chip.classList.remove('is-live'); chip.classList.add('is-ended');
msgEl.textContent = COPY.ended || 'Black Minute ended';
lockVisual(true);
}
function showLocked(text) {
chip.classList.add('is-locked');
timeEl.textContent = '';
if (barEl) barEl.style.transform = 'scaleX(0)';
msgEl.textContent = text;
lockVisual(true);
}
if (!isTodaysDrop) { return; }
var st = windowState();
if (st === 'live') renderLive();
else if (st === 'before') {
showLocked(COPY.locked || 'Available only during Black Minute');
var delay = startEpoch - now();
if (delay <= 6 * 60 * 60 * 1000) setTimeout(function () { if (windowState() === 'live') { chip.classList.remove('is-locked'); renderLive(); } }, delay);
} else { endLive(); }
}
function money(cents) {
var amount = (parseInt(cents, 10) || 0) / 100;
var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (cfg.shop && cfg.shop.currency) || 'USD';
try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(amount); }
catch (e) { return '$' + amount.toFixed(2); }
}
function imageUrl(url) {
if (!url) return '';
if (url.indexOf('//') === 0) url = 'https:' + url;
if (/cdn\.shopify\.com/.test(url) && url.indexOf('width=') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=800';
return url;
}
function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
function clockLabel(secs) { return pad(Math.floor(secs / 60)) + ':' + pad(secs % 60); }
function toMinutes(hhmm) { var m = /^(\d{1,2}):(\d{2})$/.exec((hhmm || '').trim()); return m ? (parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) : 0; }
function minutesToHHMM(min) { min = ((min % 1440) + 1440) % 1440; return pad(Math.floor(min / 60)) + ':' + pad(min % 60); }
function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function cartJanitor() {
var HOLD = 3600000;
fetch('/cart.js', { credentials: 'same-origin' })
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (cart) {
if (!cart || !cart.items) return;
var present = {};
var removals = [];
cart.items.forEach(function (item) {
if (pool.indexOf(item.handle) === -1) return;
var key = 'bm:cart:' + item.key;
present[key] = true;
var ts = 0;
try { ts = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
if (!ts) { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} return; }
if (Date.now() - ts > HOLD) removals.push(item.key);
});
try {
for (var i = localStorage.length - 1; i >= 0; i--) {
var k = localStorage.key(i);
if (k && k.indexOf('bm:cart:') === 0 && !present[k]) localStorage.removeItem(k);
}
} catch (e) {}
if (!removals.length) return;
var chain = Promise.resolve();
removals.forEach(function (id) {
chain = chain.then(function () {
return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 0 }) });
});
});
chain.then(function () {
if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
}).catch(function () {});
})
.catch(function () {});
}
syncServerClock().then(function () {
resolve();
cartJanitor();
var isPoolProduct = cfg.pageProductHandle && pool.indexOf(cfg.pageProductHandle) !== -1;
if (isPoolProduct) setupPDP();
var onLiveDropPage = isPoolProduct && todayHandle && cfg.pageProductHandle === todayHandle && liveToday;
if (liveToday && !onLiveDropPage) setupTeaser();
});
})();
